// Single source of truth for client-side poll intervals. Each constant is commented
// with the server-side cache rule it pairs with (p4a-strapi/src/middlewares/cache-control.ts)
// so a TTL change on either side is easy to reconcile against the other.

/** useRaisedFundsSummary — /raised-funds/v1/summary has no dedicated browser-cache rule; pollers request it with cache:'no-store', so freshness is fully governed by this interval. */
export const RAISED_FUNDS_POLL_MS = 15000;

/** useRaisedFundsSummary's own fallback when a caller doesn't pass pollMs (e.g. PowerHourGlow). */
export const RAISED_FUNDS_SUMMARY_DEFAULT_POLL_MS = 30000;

/** RaisedFunds.tsx (the dedicated campaign page) — faster than the default since the live total is that page's whole purpose. */
export const RAISED_FUNDS_DETAIL_POLL_MS = 20000;

/** useDonations — pairs with /api/donors max-age 3s (cache-control.ts). */
export const DONATIONS_POLL_MS = 6000;

/** DonorsOverlay's matching-donors poll — pairs with /api/matching-donors max-age 15s (cache-control.ts). */
export const MATCHING_DONORS_POLL_MS = 30000;

/** useOverlayMatches — /overlay/v1/matches. */
export const OVERLAY_MATCHES_POLL_MS = 15000;

/**
 * WidgetDonationProvider — /overlay/v1/payload. Set slightly above the overlay
 * service's default fresh-window (5000ms, DEFAULT_OVERLAY_TTL_MS in
 * p4a-strapi/src/utils/cache-config.ts, admin-clampable up to 600000ms) so the
 * client doesn't poll exactly on the fresh/stale boundary, where roughly half
 * of requests would land in the stale branch for no reason.
 */
export const WIDGET_DONATION_POLL_MS = 5500;

/**
 * Overlay settings re-poll for pages that otherwise only fetch settings once on
 * mount (DonorsOverlay, LiveDonationsOverlay). 60s is ample for a producer's
 * colour/line-count edit to reach a long-running OBS browser-source tab
 * without a reload.
 */
export const OVERLAY_SETTINGS_POLL_MS = 60000;

/** usePerks — pairs with /api/perks max-age 30s (cache-control.ts) and its 60s server-cache TTL, which the perks sync clears on every write. */
export const PERKS_POLL_MS = 60000;

/** useCampaignVersion — pairs with /api/campaign-version (always no-store) and gates the ?v= cache-buster on useActiveCampaign's /api/active-campaign request. */
export const CAMPAIGN_VERSION_POLL_MS = 30000;

/** useFeaturedVideoPage — pairs with /api/featured-video-page-version (always no-store) and gates the ?v= cache-buster on the real /api/featured-video-page request. */
export const FEATURED_VIDEO_PAGE_VERSION_POLL_MS = 30000;
